import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-payment-status-modal',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div *ngIf="show" class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-[9999]">
      <div class="bg-white rounded-2xl shadow-2xl p-10 flex flex-col items-center animate-fade-in-up min-w-[320px] relative overflow-hidden">
        <ng-container *ngIf="status === 'success'; else failedBlock">
          <div class="w-24 h-24 flex items-center justify-center mb-4">
            <svg class="w-24 h-24 animate-bounce-in" fill="none" viewBox="0 0 96 96">
              <circle cx="48" cy="48" r="44" stroke="#22c55e" stroke-width="8" fill="#dcfce7"/>
              <path d="M32 50l12 12 20-22" stroke="#22c55e" stroke-width="6" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
            </svg>
            <div class="absolute top-0 left-0 w-full h-full pointer-events-none">
              <!-- Confetti -->
              <div *ngFor="let i of confettiCount; let idx = index" [ngStyle]="getConfettiStyle(idx)" class="confetti"></div>
            </div>
          </div>
          <h2 class="text-2xl font-bold text-green-600 mb-2 animate-fade-in">Payment Successful!</h2>
          <p class="text-gray-700 text-center mb-2">Your payment was processed successfully.</p>
        </ng-container>
        <ng-template #failedBlock>
          <div class="w-24 h-24 flex items-center justify-center mb-4">
            <svg class="w-24 h-24 animate-shake" fill="none" viewBox="0 0 96 96">
              <circle cx="48" cy="48" r="44" stroke="#f87171" stroke-width="8" fill="#fee2e2"/>
              <path d="M36 36l24 24M60 36L36 60" stroke="#f87171" stroke-width="6" stroke-linecap="round"/>
            </svg>
          </div>
          <h2 class="text-2xl font-bold text-red-500 mb-2 animate-fade-in">Payment Failed</h2>
          <p class="text-gray-700 text-center mb-2">Unfortunately, your payment could not be processed.</p>
        </ng-template>
      </div>
    </div>
  `,
  styles: [
    `
    .animate-fade-in-up { animation: fadeInUp 0.5s cubic-bezier(0.23, 1, 0.32, 1); }
    .animate-fade-in { animation: fadeIn 0.5s 0.2s both; }
    .animate-bounce-in { animation: bounceIn 0.7s cubic-bezier(0.23, 1, 0.32, 1); }
    .animate-shake { animation: shake 0.7s cubic-bezier(0.23, 1, 0.32, 1); }
    .confetti {
      position: absolute;
      width: 12px;
      height: 12px;
      border-radius: 2px;
      opacity: 0.8;
      animation: confetti-fall 1.5s linear;
    }
    @keyframes fadeInUp {
      from { opacity: 0; transform: translateY(40px); }
      to { opacity: 1; transform: translateY(0); }
    }
    @keyframes fadeIn {
      from { opacity: 0; }
      to { opacity: 1; }
    }
    @keyframes bounceIn {
      0% { opacity: 0; transform: scale(0.3); }
      50% { opacity: 1; transform: scale(1.05); }
      70% { transform: scale(0.95); }
      100% { transform: scale(1); }
    }
    @keyframes shake {
      10%, 90% { transform: translateX(-2px); }
      20%, 80% { transform: translateX(4px); }
      30%, 50%, 70% { transform: translateX(-8px); }
      40%, 60% { transform: translateX(8px); }
    }
    @keyframes confetti-fall {
      0% { opacity: 0.8; transform: translateY(-20px) rotate(0deg); }
      100% { opacity: 0; transform: translateY(80px) rotate(360deg); }
    }
    `
  ]
})
export class PaymentStatusModalComponent implements OnInit {
  @Input() status: 'success' | 'failed' = 'success';
  @Input() show = false;
  @Output() closed = new EventEmitter<void>();

  confettiCount = Array.from({ length: 18 });

  ngOnInit(): void {
    if (this.show) {
      setTimeout(() => {
        this.closed.emit();
      }, 3000);
    }
  }

  getConfettiStyle(idx: number) {
    // Randomize confetti for a fun effect
    const colors = ['#fbbf24', '#34d399', '#60a5fa', '#f472b6', '#f87171', '#a78bfa'];
    const left = 16 + Math.random() * 68; // percent
    const delay = Math.random() * 0.5;
    const rotate = Math.random() * 360;
    return {
      left: `${left}%`,
      top: `${Math.random() * 20}%`,
      background: colors[idx % colors.length],
      transform: `rotate(${rotate}deg)`,
      animationDelay: `${delay}s`
    };
  }
}
